// LoadingSvg.jsx
import React from "react";
import clsx from "clsx";

export default function LoadingSvg({
  size = 160, // px
  spin = false, // activar rotación
  pulse = true, // activar pulso
  className = "",
}) {
  return (
    <div
      className={clsx("flex items-center justify-center", className)}
      style={{ width: size, height: size }}
    >
      <div
        className={clsx({
          "animate-spin": spin,
          "animate-pulse": pulse,
        })}
        style={{ width: size, height: size }}
      >
        {/* SVG original */}
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="100%" height="100%" viewBox="0 0 1076.000000 1080.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
fill="#000000" stroke="none">
<path d="M5335 10753 c-965 -39 -1893 -480 -2540 -1205 -606 -678 -924 -1516
-925 -2428 0 -374 44 -697 141 -1028 351 -1198 1293 -2136 2489 -2476 280 -80
646 -136 893 -136 l87 0 0 889 0 889 38 6 c20 3 69 8 107 11 275 25 567 130
842 305 20 13 29 6 163 -120 116 -111 140 -138 134 -155 -15 -46 -15 -93 -1
-122 14 -26 271 -281 1013 -1004 94 -91 183 -175 199 -185 24 -15 48 -19 130
-19 88 0 107 3 160 28 80 37 122 71 156 125 65 103 91 261 56 342 -15 33 -251
268 -950 945 -295 286 -303 291 -380 261 l-42 -16 -127 127 c-71 70 -128 130
-128 133 0 3 29 40 63 82 146 183 255 403 330 668 34 119 67 321 67 411 l0 39
907 0 906 0 -6 168 c-18 508 -143 995 -376 1463 -416 838 -1168 1499 -2051
1805 -327 113 -636 172 -1005 194 -163 9 -194 10 -350 3z m2061 -1498 c28 -16
49 -39 63 -68 20 -42 21 -58 21 -445 l0 -402 -175 0 -175 0 -58 58 c-78 80
-136 106 -233 107 l-77 0 -68 64 c-67 63 -197 164 -255 198 l-29 17 0 189 c0
200 4 219 52 264 12 12 34 26 48 32 15 6 187 10 434 10 l409 1 43 -25z m-4100
-94 c46 -28 61 -80 37 -128 -23 -47 -56 -65 -108 -59 -53 6 -85 43 -85 97 0
50 13 74 48 93 37 21 71 19 108 -3z m344 4 c37 -19 50 -43 50 -92 0 -47 -19
-76 -59 -93 -92 -38 -178 53 -134 140 29 57 86 75 143 45z m350 -2 c16 -9 33
-27 39 -40 49 -108 -74 -202 -161 -124 -28 25 -33 36 -33 76 0 40 5 51 33 76
37 33 79 38 122 12z m366 -17 c26 -26 34 -42 34 -71 0 -52 -53 -105 -105 -105
-52 0 -105 53 -105 105 0 52 53 105 105 105 29 0 45 -8 71 -34z m3621 -157
c37 -18 49 -32 73 -83 16 -33 55 -92 86 -131 31 -38 72 -93 91 -122 35 -51 35
-52 31 -148 l-3 -97 -37 -34 c-52 -47 -78 -45 -143 15 -132 120 -243 121 -366
2 -47 -45 -58 -51 -95 -51 -34 0 -47 5 -63 26 -20 26 -21 39 -21 301 l0 275
34 34 34 34 168 0 c150 0 172 -2 211 -21z m-4685 -59 c53 -15 92 -52 107 -102
l13 -43 24 52 c14 34 34 59 55 72 93 57 221 23 249 -67 18 -56 27 -59 41 -13
41 137 265 145 309 11 7 -23 17 -43 21 -45 4 -3 13 15 20 39 37 125 254 139
304 19 8 -20 15 -39 15 -43 0 -5 -37 -34 -82 -66 -46 -31 -104 -74 -129 -96
-26 -21 -50 -38 -53 -38 -3 0 -6 17 -7 38 l-1 37 -11 -32 c-27 -74 -73 -80
-101 -15 l-15 37 0 -33 c-1 -18 6 -49 14 -69 21 -49 19 -61 -14 -97 -16 -17
-43 -47 -60 -66 l-30 -35 -1 53 c0 45 -3 52 -20 52 -18 0 -20 -7 -20 -81 l0
-80 -42 3 -43 3 -3 78 c-3 69 -5 77 -22 77 -25 0 -25 16 0 80 11 28 20 65 20
83 l-1 32 -17 -35 c-29 -59 -82 -52 -99 13 -5 22 -10 -27 -13 -148 l-5 -180
-42 -3 -43 -3 0 135 c0 113 -2 136 -15 136 -12 0 -15 -24 -17 -132 l-3 -133
-42 -3 -43 -3 -1 193 c0 179 -1 190 -15 154 -19 -52 -32 -66 -61 -66 -18 0
-28 9 -43 43 -18 41 -19 41 -19 12 -1 -16 7 -52 18 -80 35 -94 35 -95 7 -95
-26 0 -26 -1 -26 -75 l0 -75 -45 0 -45 0 0 75 c0 60 -3 75 -15 75 -12 0 -15
-15 -15 -75 l0 -75 -45 0 -45 0 0 75 c0 73 -1 75 -25 75 -31 0 -31 5 1 84 15
38 24 78 22 98 l-4 33 -12 -43 c-18 -59 -68 -77 -92 -33 -11 21 61 246 87 272
20 20 87 47 118 48 11 1 37 -4 57 -9z m2385 -275 c547 -98 995 -489 1166
-1020 54 -169 70 -274 70 -470 0 -196 -16 -301 -70 -470 -187 -580 -715 -995
-1315 -1033 -534 -35 -1010 191 -1325 627 -69 94 -169 289 -202 391 -224 699
54 1435 681 1801 175 102 397 171 623 193 70 7 291 -4 372 -19z m1273 -280
c37 -35 52 -73 48 -120 l-3 -38 -34 49 c-19 27 -52 70 -73 95 -21 26 -38 49
-38 52 0 14 76 -15 100 -38z m1029 7 c118 -88 55 -272 -94 -272 -114 0 -186
108 -141 213 38 90 154 119 235 59z m-4051 -2382 c20 -25 52 -62 71 -83 26
-27 32 -40 23 -45 -8 -6 14 -47 78 -142 50 -73 88 -135 85 -138 -3 -3 -32 2
-65 11 -33 10 -64 17 -70 17 -5 0 47 -86 117 -190 69 -105 124 -192 121 -195
-4 -5 -63 5 -305 49 l-73 13 0 -128 0 -129 38 0 c87 -1 292 -62 292 -88 0 -4
-21 -20 -46 -36 -54 -34 -165 -143 -191 -186 l-17 -30 -468 0 c-414 0 -467 2
-462 15 11 26 133 122 215 167 l78 43 1 83 0 84 -92 -7 c-51 -3 -108 -8 -127
-11 l-33 -5 23 37 c12 20 49 75 81 122 32 47 56 87 54 89 -2 3 -21 0 -42 -6
-21 -6 -40 -9 -42 -6 -2 2 21 40 52 83 31 44 56 83 56 87 0 4 -13 4 -30 0 -23
-5 -30 -3 -30 9 0 8 4 18 10 21 5 3 43 55 85 115 42 61 78 110 80 110 2 0 23
-27 45 -60 22 -33 44 -60 48 -60 4 0 47 59 95 131 l88 131 -55 -7 c-31 -4 -56
-5 -56 -1 0 3 52 80 116 171 l116 165 50 -78 c28 -42 67 -97 86 -122z m733
-574 c41 -18 91 -40 112 -47 26 -9 50 -29 74 -62 19 -26 33 -50 30 -53 -3 -3
-21 -1 -41 4 l-35 10 17 -26 c9 -15 41 -62 70 -105 30 -43 52 -80 49 -83 -3
-3 -37 -1 -76 5 -38 6 -81 11 -95 11 l-26 0 0 -102 0 -103 54 -28 c59 -31 167
-115 174 -134 3 -10 -91 -13 -447 -13 -353 0 -451 3 -451 12 0 7 33 44 73 83
64 61 137 108 200 129 12 4 17 16 17 39 l0 34 -47 -8 c-25 -5 -49 -7 -52 -4
-5 5 6 27 51 103 l20 33 -27 -7 c-30 -8 -30 -6 8 50 15 22 17 30 7 36 -15 9
-11 16 44 87 22 28 43 50 48 47 10 -6 88 -120 88 -128 0 -4 -7 -6 -15 -6 -13
0 -13 -3 -3 -20 7 -11 15 -20 18 -20 6 1 70 105 70 114 0 3 -12 1 -26 -4 -55
-21 -55 -11 -4 65 50 74 50 75 25 75 -29 0 -30 3 -13 30 17 26 23 26 109 -14z"/>
<path d="M7690 8751 l0 -111 154 0 155 0 -47 105 -46 105 -55 0 c-31 0 -80 3
-108 6 l-53 7 0 -112z"/>
<path d="M5255 8514 c-315 -44 -586 -172 -803 -379 -122 -116 -209 -233 -282
-380 -97 -197 -140 -379 -140 -595 0 -363 133 -681 395 -946 202 -204 417
-321 706 -386 88 -20 132 -23 289 -23 194 0 290 14 452 66 90 29 251 109 343
170 103 69 265 226 338 327 118 165 208 375 241 567 21 116 21 334 0 450 -85
495 -457 916 -944 1069 -149 48 -216 58 -395 61 -93 2 -183 1 -200 -1z m405
-160 c154 -29 336 -101 458 -182 l53 -35 -29 -13 c-16 -6 -33 -17 -36 -23 -4
-6 -25 -15 -48 -21 -22 -6 -51 -22 -63 -34 -13 -13 -39 -33 -58 -45 -30 -18
-36 -19 -47 -6 -9 11 -8 20 10 45 12 17 20 35 18 41 -2 6 -30 22 -63 35 -91
37 -128 28 -198 -50 -57 -62 -127 -182 -127 -218 0 -32 50 -96 80 -103 59 -13
90 24 90 108 0 42 5 58 21 73 l22 19 -7 -47 c-6 -38 -4 -50 11 -65 17 -17 20
-63 4 -63 -5 0 -29 -16 -54 -35 -27 -20 -57 -35 -73 -35 -17 0 -39 -11 -56
-27 -25 -24 -29 -25 -45 -11 -10 8 -32 20 -49 27 -21 8 -38 26 -52 57 -30 62
-56 58 -60 -9 -3 -40 -7 -49 -28 -57 -13 -5 -24 -15 -24 -22 0 -21 43 -58 67
-58 13 0 23 -4 23 -10 0 -5 8 -10 17 -10 13 0 14 -3 5 -12 -7 -7 -12 -22 -12
-34 0 -16 8 -23 30 -27 39 -8 38 -30 -2 -54 -18 -11 -40 -32 -48 -47 -21 -40
-4 -61 51 -61 40 0 45 3 58 32 8 17 24 36 37 42 13 6 24 17 24 26 0 12 12 15
55 15 53 0 55 -1 69 -35 16 -38 35 -44 61 -19 12 13 19 13 30 4 11 -9 21 -9
45 2 29 12 30 15 24 54 -5 36 -3 44 17 58 30 21 118 50 127 42 12 -13 -15 -40
-54 -53 -44 -15 -64 -37 -64 -70 0 -25 26 -43 63 -43 22 0 37 -16 37 -41 0 -5
-13 -9 -29 -9 -37 0 -91 -19 -116 -40 -27 -24 -62 -33 -70 -20 -12 20 -68 37
-182 57 -28 4 -40 -1 -88 -42 -41 -36 -59 -60 -73 -98 -12 -37 -27 -57 -55
-76 -35 -25 -37 -28 -31 -66 3 -22 6 -82 5 -132 l-2 -93 33 -20 c24 -15 51
-20 103 -21 39 0 104 -4 146 -7 74 -7 78 -9 120 -52 29 -29 43 -52 41 -66 -2
-12 3 -28 10 -35 7 -8 14 -36 15 -62 1 -26 6 -53 11 -60 6 -7 15 -32 21 -57
11 -43 29 -92 57 -155 18 -40 75 -101 104 -110 26 -8 50 14 50 46 0 10 16 27
36 39 44 28 56 47 89 140 15 41 31 79 36 84 5 6 9 21 9 35 0 15 11 58 24 96
21 61 36 147 53 310 5 46 -8 63 -67 85 -51 19 -83 44 -115 87 -17 23 -21 32
-9 22 49 -40 121 -70 182 -76 78 -7 82 -3 82 89 0 47 -5 71 -16 82 -28 28 62
20 126 -12 53 -26 55 -29 73 -90 15 -50 26 -68 51 -83 17 -10 39 -19 49 -19
22 0 21 -13 -2 -126 -127 -597 -718 -1020 -1338 -955 -65 6 -158 23 -208 37
-49 14 -100 28 -112 31 l-23 5 20 28 c11 16 20 33 20 39 0 6 8 15 18 20 18 10
64 86 76 128 8 26 68 128 90 152 28 31 30 69 6 119 -12 26 -27 56 -32 67 -10
22 -39 37 -103 54 -41 11 -167 81 -218 121 -35 27 -131 37 -197 20 -94 -24
-97 -24 -145 11 -47 36 -56 51 -57 99 -2 58 -62 76 -110 34 -15 -14 -17 -12
-23 15 -12 57 1 84 59 115 52 28 76 29 76 1 0 -28 22 -62 52 -80 30 -17 32
-17 45 1 8 11 11 28 7 39 -3 11 -13 46 -22 79 -14 55 -14 60 4 95 30 58 104
160 126 175 17 12 19 19 11 43 -5 15 -24 38 -41 49 -31 21 -31 22 -12 39 14
12 28 16 50 12 23 -5 34 -1 49 15 22 23 37 94 27 132 -6 24 -9 25 -56 19 -49
-6 -50 -5 -61 26 -12 34 -16 36 -53 21 -29 -11 -32 -4 -15 34 6 13 20 27 31
30 42 11 -4 91 -79 138 -18 11 -33 25 -33 32 0 6 24 36 54 65 l55 54 54 -33
c56 -34 63 -46 82 -138 4 -21 26 -52 61 -87 30 -29 54 -58 54 -63 0 -6 13 -13
28 -17 24 -5 35 1 73 39 28 28 60 48 87 55 32 9 49 22 69 52 24 37 26 44 16
87 -5 26 -13 55 -17 64 -6 13 -1 21 17 29 18 8 30 28 46 77 19 59 19 68 6 89
-21 31 -19 40 13 57 37 19 62 64 42 76 -9 6 1 10 31 14 24 3 58 8 74 10 56 8
260 -4 345 -20z m-527 -25 c-5 -5 -32 -13 -59 -18 -27 -5 -57 -12 -66 -16 -10
-4 -18 -3 -18 3 0 5 10 12 23 15 12 3 45 12 72 20 52 15 66 14 48 -4z m-703
-520 c0 -15 4 -39 10 -53 7 -19 6 -26 -2 -26 -19 0 -48 -32 -48 -54 0 -11 12
-32 27 -48 25 -26 25 -29 12 -65 -12 -32 -20 -39 -47 -41 -21 -2 -41 4 -58 17
-15 12 -37 21 -50 21 -35 0 -31 24 25 132 63 124 99 172 117 157 8 -6 14 -24
14 -40z m977 -161 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m353
-173 c0 -25 -6 -25 -50 3 -7 4 23 22 38 22 6 0 12 -11 12 -25z m460 -180 c13
-14 20 -25 16 -25 -15 0 -66 31 -66 40 0 18 26 10 50 -15z m-164 -29 c3 -8 4
-25 2 -38 -2 -19 -5 -17 -15 15 -10 35 1 55 13 23z m-1747 -487 c36 -6 71 -15
76 -19 6 -4 27 -13 47 -19 20 -7 40 -21 43 -31 3 -11 22 -25 42 -32 l36 -13
-6 -76 c-6 -77 -6 -77 32 -130 20 -30 43 -72 49 -95 6 -22 28 -61 48 -87 23
-30 38 -61 41 -89 l6 -42 -69 53 c-133 103 -254 241 -332 381 -26 46 -92 194
-92 206 0 6 7 5 79 -7z"/>
<path d="M3548 5603 l-48 -14 27 -40 c14 -21 28 -39 32 -39 6 0 71 96 71 105
0 8 -32 4 -82 -12z"/>
<path d="M3681 5279 c-51 -10 -98 -20 -103 -21 -5 -2 18 -42 52 -90 33 -48 60
-89 60 -93 0 -3 -15 -4 -32 -1 -18 3 -72 8 -120 12 l-88 6 0 -67 c0 -43 4 -64
10 -60 20 12 145 45 210 55 36 6 77 13 93 16 l27 6 0 129 c0 71 -3 129 -7 128
-5 -1 -50 -10 -102 -20z"/>
<path d="M4555 5073 c-55 -7 -57 -10 -35 -45 11 -18 20 -37 20 -42 0 -8 -50
-2 -92 10 -14 4 -18 -1 -18 -25 0 -29 2 -30 58 -36 31 -3 85 -12 120 -19 l62
-13 0 88 0 89 -42 -1 c-24 -1 -56 -4 -73 -6z"/>
<path d="M1651 2948 c-66 -10 -146 -52 -177 -93 -59 -78 -71 -183 -30 -270 35
-75 89 -111 273 -180 92 -34 133 -70 133 -118 0 -52 -45 -87 -112 -87 -70 0
-113 23 -145 79 -15 25 -27 47 -29 49 -3 5 -164 -25 -171 -32 -11 -10 16 -82
50 -132 85 -128 298 -172 461 -96 70 33 101 68 122 139 40 133 -12 255 -134
317 -26 13 -80 35 -120 50 -95 34 -127 51 -146 78 -25 36 -20 76 14 110 29 29
34 30 92 26 53 -4 65 -9 87 -35 14 -16 31 -38 36 -48 10 -16 17 -17 84 -7 40
6 75 13 78 16 12 12 -10 78 -40 123 -60 90 -188 134 -326 111z"/>
<path d="M2505 2950 c-101 -14 -169 -46 -241 -112 -106 -100 -152 -224 -141
-378 19 -242 178 -407 410 -426 177 -15 351 67 417 195 l20 40 -22 15 c-13 8
-49 27 -82 42 -52 24 -60 25 -68 11 -44 -79 -112 -116 -211 -117 -79 0 -120
15 -175 64 -62 56 -85 121 -80 225 4 96 22 144 73 196 51 50 100 70 180 69 85
0 135 -23 192 -89 l38 -45 73 35 c45 21 72 40 72 50 0 27 -26 68 -72 111 -94
91 -237 133 -383 114z"/>
<path d="M7692 2949 c-88 -11 -181 -57 -251 -124 -104 -99 -147 -210 -138
-359 3 -51 13 -112 23 -138 65 -170 223 -282 419 -295 362 -25 606 336 450
664 -88 187 -276 281 -503 252z m157 -185 c66 -19 131 -77 166 -147 20 -40 25
-66 25 -121 0 -83 -20 -134 -75 -194 -155 -172 -441 -68 -462 167 -12 134 70
256 199 296 57 18 84 18 147 -1z"/>
<path d="M3097 2933 c-11 -11 -8 -871 3 -878 5 -3 132 -6 282 -7 l273 -2 3 87
3 87 -186 0 -185 0 0 90 c0 65 3 90 13 91 6 0 80 1 162 2 l150 2 0 85 0 85
-162 3 -163 2 0 95 0 95 185 0 185 0 0 85 0 85 -278 0 c-153 0 -282 -3 -285
-7z"/>
<path d="M3820 2495 l0 -446 93 3 92 3 0 278 c0 152 2 277 5 277 3 0 91 -112
197 -248 276 -355 235 -316 329 -316 l79 -1 3 448 2 447 -95 0 -95 0 0 -282
c-1 -253 -2 -281 -16 -263 -8 11 -105 138 -217 282 l-202 262 -87 0 -88 1 0
-445z"/>
<path d="M4932 2588 c-205 -517 -209 -528 -191 -539 7 -5 52 -8 99 -6 l85 4
36 94 35 94 164 3 c90 1 168 -2 173 -7 5 -5 22 -46 38 -91 16 -46 30 -84 31
-85 6 -5 197 -12 202 -8 6 6 -9 46 -190 518 l-142 370 -100 3 -100 3 -140
-353z m297 -31 c28 -82 51 -150 51 -152 0 -1 -49 -3 -110 -3 -60 -1 -110 2
-110 6 0 20 106 310 111 304 4 -4 30 -74 58 -155z"/>
<path d="M5577 2933 c-9 -8 -9 -126 -1 -147 5 -13 25 -16 120 -16 l114 0 0
-360 0 -360 100 0 100 0 0 360 0 360 120 0 120 0 0 85 0 85 -333 0 c-184 0
-337 -3 -340 -7z"/>
<path d="M6380 2495 c0 -290 3 -445 10 -445 6 -1 47 -1 93 -1 l82 -1 5 189 5
188 193 3 192 2 0 -190 0 -190 100 0 100 0 0 445 0 445 -100 0 -100 0 0 -170
0 -170 -192 2 -193 3 -2 145 c-1 80 -2 155 -3 168 0 21 -3 22 -95 22 l-95 0 0
-445z"/>
<path d="M8380 2495 l0 -445 95 0 95 0 2 280 3 280 215 -276 c118 -152 221
-279 230 -282 8 -3 49 -6 90 -7 l75 0 3 448 2 448 -96 -3 -95 -3 1 -278 c0
-167 -3 -277 -9 -275 -5 1 -40 44 -77 93 -38 50 -134 175 -214 278 l-145 187
-87 0 -88 0 0 -445z"/>
<path d="M4395 1738 c-3 -7 -4 -209 -3 -448 l3 -435 283 -3 282 -2 0 85 c0 74
-2 85 -17 86 -10 0 -92 1 -183 2 l-165 2 -3 363 -2 362 -95 0 c-67 0 -97 -4
-100 -12z"/>
<path d="M5350 1724 c-6 -14 -19 -46 -30 -72 -29 -70 -269 -689 -291 -750
l-18 -53 101 3 100 3 17 45 c10 25 25 66 35 93 l18 47 173 0 173 0 33 -95 34
-95 98 0 c53 0 97 4 97 9 0 16 -310 833 -331 874 -8 14 -24 17 -105 17 -92 0
-95 -1 -104 -26z m164 -363 c31 -84 56 -155 56 -157 0 -2 -52 -4 -116 -4 -89
0 -115 3 -112 13 21 61 113 306 114 304 1 -1 28 -71 58 -156z"/>
<path d="M5990 1301 l0 -451 228 0 c253 0 289 6 355 61 59 49 81 101 82 189 0
95 -30 154 -98 190 l-44 23 41 31 c131 99 111 299 -39 379 -37 21 -56 22 -282
25 l-243 3 0 -450z m348 279 c88 0 133 -93 78 -157 -23 -27 -28 -28 -130 -31
l-106 -4 0 94 c0 52 3 97 6 101 3 3 29 4 58 2 28 -2 70 -4 94 -5z m27 -350
c78 -18 115 -92 80 -159 -19 -38 -52 -49 -161 -54 l-92 -4 -4 106 c-3 58 -3
109 -1 114 6 10 130 8 178 -3z"/>
</g>
</svg>
      </div>
    </div>
  );
}
